import LoadingSpinnerFull from "~/components/LoadingSpinners/LoadingSpinnerFull";

const TableRowLoadingSpinner = () => {
	return <tr>
		<td colSpan={10}
			className="h-12"><LoadingSpinnerFull theme="neutral" /></td>
	</tr>;
};

export default TableRowLoadingSpinner;